import { createStyles } from '@material-ui/core'

export default () =>
  createStyles({
    tableContainer: {
      maxWidth: 500,
      marginBottom: 20,
    },
  })
